import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import {
  User,
  FirstTimeUser,
  SwitchRole,
  APIResponse,
  Division,
  TicketCount,
  AddUserData,
  EditUserData,
  EditProfileData,
  LoginData
} from '../models';

import { ApiService } from './api.service';

@Injectable()
export class UserService {
  constructor(private http: Http, private apiService: ApiService) {}

  addUser(data: AddUserData): Observable<APIResponse<any, any>> {
    return this.apiService.post('/user/add', data);
  }

  changePassword(data: any): Observable<APIResponse<any, any>> {
    return this.apiService.post('/password/change', data);
  }

  editUser(data: EditUserData): Observable<APIResponse<any, any>> {
    return this.apiService.put('/user/edit', data);
  }

  editprofile(data: EditProfileData): Observable<APIResponse<any, any>> {
    return this.apiService.put('/user/profile/edit', data);
  }

  deleteUser(updatedata: string): Observable<APIResponse<any, any>> {
    return this.apiService.delete('/user/delete/' + updatedata);
  }

  getDivision(): Observable<APIResponse<Division, any>> {
    return this.apiService.get('/division');
  }

  getCountedDivision() {
    return this.apiService.get('/division/count');
  }

  getCountedTickets(
    payload: string
  ): Observable<APIResponse<TicketCount, any>> {
    return this.apiService.get('/ticket/count/' + payload);
  }

  getCurrentUserProfile(): Promise<APIResponse<User, any>> {
    return this.apiService.getPromise('/user/profile');
  }

  getCurrentUserActivities(): Observable<APIResponse<any, any>> {
    return this.apiService.get('/user/activities');
  }

  getUserCategories(payload: string): Observable<APIResponse<any, any>> {
    return this.apiService.get('/user/categories/' + payload);
  }

  getUsers(requestType: string): Observable<APIResponse<User[], any>> {
    return this.apiService.get('/users/' + requestType);
  }

  // triggered when user click agree in legal agreement page
  hasAgreeTerms() {
    return this.apiService.get('/terms/agree');
  }

  login(data: LoginData): Promise<APIResponse<FirstTimeUser, any>> {
    return this.apiService.postPromise('/login', data);
  }

  resetPassword(email: any): Observable<APIResponse<any, any>> {
    return this.apiService.post('/password/reset', email);
  }

  switchRole(i: number): Promise<APIResponse<SwitchRole, any>> {
    return this.apiService.getPromise('/user/switchrole/' + i);
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/services/user.service.ts